'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _WebformElement = require('../WebformElement');

var _WebformElement2 = _interopRequireDefault(_WebformElement);

var _wrapper = require('./styled/wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _validationIcon = require('./styled/validation-icon');

var _validationIcon2 = _interopRequireDefault(_validationIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Select2
 * @source https://github.com/JedWatson/react-select
 */

var SelectField = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SelectField, _Component);

  function SelectField(props) {
    (0, _classCallCheck3.default)(this, SelectField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SelectField, [{
    key: 'getLabelPosition',
    value: function getLabelPosition() {
      return this.props.webformElement.getLabelDisplay();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(value) {
      var newValue = value || '';
      if (newValue && newValue.value) {
        this.props.onChange(newValue.value);
      } else {
        this.props.onChange(newValue);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var options = this.props.field['#options'] || {};
      var mappedOptions = options.map(function (option) {
        return {
          label: option.text,
          value: option.value
        };
      });
      return _react2.default.createElement(
        _wrapper2.default,
        {
          labelDisplay: this.getLabelPosition(),
          success: this.props.webformElement.isValid(),
          className: 'hrw-select-wrapper'
        },
        _react2.default.createElement(_reactSelect2.default, {
          name: this.props.field['#webform_key'],
          id: this.props.field['#webform_key'],
          value: this.props.value,
          multi: this.props.field['#multiple'],
          options: mappedOptions,
          onChange: this.handleChange,
          onBlur: this.props.onBlur,
          disabled: !this.props.state.enabled,
          required: this.props.state.required,
          autoBlur: true,
          placeholder: this.props.field['#empty_option'] || 'Selecteer...',
          openAfterFocus: true,
          joinValues: true
        }),
        _react2.default.createElement(_validationIcon2.default, { success: this.props.webformElement.isSuccess(), className: 'hrw-validation-icon' })
      );
    }
  }]);
  return SelectField;
}(_react.Component), _class.propTypes = {
  field: _propTypes2.default.shape({
    '#title_display': _propTypes2.default.string.string,
    '#options': _propTypes2.default.arrayOf(_propTypes2.default.shape({
      value: _propTypes2.default.node,
      text: _propTypes2.default.node
    })),
    '#webform_key': _propTypes2.default.string.isRequired,
    '#multiple': _propTypes2.default.bool,
    '#empty_option': _propTypes2.default.string
  }).isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]).isRequired,
  webformElement: _propTypes2.default.instanceOf(_WebformElement2.default).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  state: _propTypes2.default.shape({
    required: _propTypes2.default.bool.isRequired,
    enabled: _propTypes2.default.bool.isRequired
  }).isRequired
}, _temp);
exports.default = SelectField;